import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import { addAnimations } from './Animations';

export default class LetterBox extends Phaser.GameObjects.Container {
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, position, number) {
        super(scene);

        this.letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q",
            "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

        this.words = ["Apple", "Butterfly", "Cat", "Dolphin", "Earth", "Fish", "Grapes", "House", "Igloo",
            ((ABCyaLib.Environment.instance.locale === 'en-GB' || ABCyaLib.Environment.instance.locale === 'en-AU' || ABCyaLib.Environment.instance.locale === 'en-CA') ? "Jam" : "Jelly"), 
            "Kite", "Lion", "Mittens", "Nut", "Orange", "Pencil", "Queen",
            "Rocket", "Strawberry", "Tomato", "Umbrella", "Violin", "Watermelon", "Xylophone", "Yoyo", "Zebra"];

        this.letter = this.letters[number];
        this.isFilled = false;

        this.parentObject = scene;

        this.number = number;
        this.position = position;
        this.suffix = null;

        let sheet = null;

        switch (this.position) {
            case 1:
                sheet = "chest-1-2";
                break;
            case 2:
                sheet = "chest-3-4";
                break;
            case 3:
                sheet = "chest-5";
                break;
            case 4:
                sheet = "chest-6";
                break;
            case 5:
                sheet = "chest-7-8";
                break;
            case 6:
                sheet = "chest-9-10";
                break;
            case 7:
                sheet = "chest-9-10";
                break;
        }

        //create static shark
        this.sharkAnimation = this.scene.add.sprite(0, 0, "sharkBite", "0");

        this.chestAnimation = this.scene.add.sprite(0, 0, sheet, "0");
        addAnimations(this.chestAnimation, sheet);
        this.add(this.chestAnimation);

        this.createBodyDef();

        this.on(Phaser.GameObjects.Events.ADDED_TO_SCENE, () => this.adjustShark());

        this.word = this.words[number];
        this.textLabel = ABCyaPhaser.Text.addText(this.chestAnimation.width / 2 - 50, this.chestAnimation.height / 2 - 58, 22, 0xffffff, FontKeys._odin_roundedregular, this.word, this).setOrigin(0.5);

        this.sharkIsEating = false;
    }

    // Original Createjs game centered the container origin, which isn't possible in Phaser, this fixes it
    centerContainer() {
        this.chestAnimation.x -= this.chestAnimation.width / 2;
        this.chestAnimation.y -= this.chestAnimation.height / 2;
        this.textLabel.x -= this.chestAnimation.width / 2;
        this.textLabel.y -= this.chestAnimation.height / 2;
    }

    createBodyDef() {
        let fixture = new Box2D.Dynamics.b2FixtureDef;
        fixture.density = 1;
        fixture.restitution = 0.6;
        fixture.shape = new Box2D.Collision.Shapes.b2PolygonShape.AsBox(30, 30);

        this.fixture = fixture;

        let bodyDef = new Box2D.Dynamics.b2BodyDef;
        bodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;

        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this);
        bodyDef.position.x = globalPt.x / SCALE;
        bodyDef.position.y = globalPt.y / SCALE;

        this.bodyDef = bodyDef;
    }

    adjustShark() {
        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this.chestAnimation);

        this.sharkAnimation.x = globalPt.x + 30;
        this.sharkAnimation.y = globalPt.y + 42;

        this.parentObject.children.moveTo(this.sharkAnimation, 1);
    }

    showWord() {
        this.scene.tweens.killTweensOf(this.textLabel);
        this.textLabel.alpha = 1;
    }

    getHalfBoundsRect() {
        let xAdj = 0;
        let widthAdj = 0;
        switch (this.position) {
            case 1:
                xAdj = -10;
                widthAdj = 10;
                break;
            case 2:
                xAdj = -5;
                break;
            case 3:
                xAdj = -5;
                break;
            case 4:
                xAdj = 5;
                break;
            case 5:
                xAdj = 10;
                widthAdj = 5;
                break;
            case 6:
            case 7:
                xAdj = 5;
                break;
        }
        let rect = new Phaser.Geom.Rectangle(this.x - this.chestAnimation.width / 6 - 4 +xAdj, this.y , this.chestAnimation.width / 4 + 16+widthAdj, this.chestAnimation.height / 4);
        return rect;
    }

    correct() {
        this.isFilled = true;

        this.animateClosing(this.number);
    }

    animateClosing(number) {
        this.chestAnimation.play("Shut");

        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._chest, this.scene, 1, false, 0.4);

        this.scene.time.delayedCall(1200, this.showIcon, [number], this);

        ABCyaPhaser.Tweens.addTween(this.textLabel, 1000, { delay: 800, alpha: 0 }, Phaser.Math.Easing.Linear);
    }

    showIcon(number) {
        let letter = this.letters[number];

        let adjustX = 0;
        let adjustY = 0;

        switch (letter) {
            case 'A':
                adjustX = 0;
                adjustY = 0;
                break;
            case 'B':
                adjustX = 4;
                adjustY = 0;
                break;
            case 'C':
                adjustX = 2;
                adjustY = 0;
                break;
            case 'D':
                adjustX = 20;
                adjustY = 0;
                break;
            case 'E':
                adjustX = 20;
                adjustY = 0;
                break;
            case 'F':
                adjustX = 21;
                adjustY = 0;
                break;
            case 'G':
                adjustX = 0;
                adjustY = 0;
                break;
            case 'H':
                adjustX = 4;
                adjustY = -3;
                break;
            case 'I':
                adjustX = 4;
                adjustY = 0;
                break;
            case 'J':
                adjustX = 18;
                adjustY = 0;
                break;
            case 'K':
                adjustX = 15;
                adjustY = 0;
                break;
            case 'L':
                adjustX = 22;
                adjustY = 0;
                break;
            case 'M':
                adjustX = -3;
                adjustY = 0;
                break;
            case 'N':
                adjustX = 4;
                adjustY = 0;
                break;
            case 'O':
                adjustX = 4;
                adjustY = 0;
                break;
            case 'P':
                adjustX = 17;
                adjustY = 0;
                break;
            case 'Q':
                adjustX = 18;
                adjustY = 0;
                break;
            case 'R':
                adjustX = 22;
                adjustY = -2;
                break;
            case 'S':
                adjustX = 22;
                adjustY = 0;
                break;
            case 'T':
                adjustX = 0;
                adjustY = 0;
                break;
            case 'U':
                adjustX = 3;
                adjustY = 0;
                break;
            case 'V':
                adjustX = 1;
                adjustY = 0;
                break;
            case 'W':
                adjustX = 16;
                adjustY = 0;
                break;
            case 'X':
                adjustX = 18;
                adjustY = -2;
                break;
            case 'Y':
                adjustX = 22;
                adjustY = 0;
                break;
            case 'Z':
                adjustX = 22;
                adjustY = 0;
                break;
        }

        this.icon = ABCyaPhaser.Images.addImage(0, 0, this.letter, this, "sprites").setOrigin(0.5);
        this.icon.x = -58 + adjustX;
        this.icon.y = 14 + adjustY;
        this.icon.scale = 0.60;
    }

    incorrect(number) {
        this.animateShark(number, 0xffffff);
    }

    animateShark(number, color) {
        if(this.sharkIsEating) return;

        this.sharkIsEating = true;
        this.sharkAnimation.play("Bite");
        this.scene.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this.sharkAnimation, 300, { delay: 10, y: this.sharkAnimation.y - 100 }, Phaser.Math.Easing.Linear, () => this.putNumberInSharkMouth(number, color)),
                    ABCyaPhaser.Tweens.createTween(this.sharkAnimation, 800, { delay: 1000, y: this.sharkAnimation.y }, Phaser.Math.Easing.Linear, () => this.sharkAnimation.stop().setFrame("0")),
                ],
                onComplete: ()=> this.sharkIsEating = false
        });
    }

    putNumberInSharkMouth(number, color) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._shark, this.scene);
        let letter = this.letters[number];

        this.sharkText = ABCyaPhaser.Text.addText(80-this.chestAnimation.width/2, -this.chestAnimation.height/2, 26, color, FontKeys._odin_roundedregular, letter, this).setOrigin(0.5);
        ABCyaPhaser.Tweens.addTween(this.sharkText, 1000, { scale: 0.2 }, Phaser.Math.Easing.Linear, () => this.sharkText.destroy());
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;